
import { Mixins } from "vue-property-decorator";

export default class SignIn extends Mixins() {
}
